import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";

export const getPortfolioDomainItemLabel = (
	domain: ClientPortfolioDomainEnum,
) => {
	switch (domain) {
		case ClientPortfolioDomainEnum.BankingProducts:
			return Resources.Portfolio.AddItem.Items.bankProduct;
		case ClientPortfolioDomainEnum.BuildingSavings:
			return Resources.Portfolio.AddItem.Items.buildingSavings;
		case ClientPortfolioDomainEnum.Investments:
			return Resources.Portfolio.AddItem.Items.investment;
		case ClientPortfolioDomainEnum.PensionProducts:
			return Resources.Portfolio.AddItem.Items.pension;
		case ClientPortfolioDomainEnum.Cryptocurrencies:
			return Resources.Portfolio.AddItem.Items.crypto;
		case ClientPortfolioDomainEnum.LifeInsurance:
			return Resources.Portfolio.AddItem.Items.lifeInsurance;
		case ClientPortfolioDomainEnum.Leasing:
			return Resources.Portfolio.AddItem.Items.leasing;
		case ClientPortfolioDomainEnum.BusinessLoans:
			return Resources.Portfolio.AddItem.Items.businessLoan;
		case ClientPortfolioDomainEnum.Services:
			return Resources.Portfolio.AddItem.Items.service;
		default:
			return Resources.Portfolio.List.PortfolioDomainType[domain];
	}
};
